import Vue from 'vue';
import Router from 'vue-router';
import { getToken } from '@/utils/auth'
import { CouponCell } from 'vant';
Vue.use(Router);
const routes = [{
        path: '/login',
        name: 'Login',
        component: () =>
            import ('./view/login/index')
    },
    {
        path: '/register',
        name: 'Register',
        component: () =>
            import ('./view/login/register')
    },
    {
        path: '/forgetPsd',
        name: 'ForgetPsd',
        component: () =>
            import ('./view/login/forgetPsd')
    },
    {
        path: '/regText',
        name: 'RegText',
        component: () =>
            import ('./view/login/regText')
    },
    {
        path: '/',
        redirect: '/home',
        component: () =>
            import ('./view/Main'),
        children: [{
                path: 'home',
                name: 'home',
                component: () =>
                    import ('./view/home')
            },
            {
                path: 'shopCar',
                name: 'shopCar',
                component: () =>
                    import ('./view/shopCar')
            },
            {
                path: 'myOrder',
                name: 'myOrder',
                component: () =>
                    import ('./view/myOrder')
            },
            {
                path: 'personal',
                name: 'personal',
                component: () =>
                    import ('./view/personal')
            },
        ]
    },
    {
        path: '/team',
        name: 'team',
        component: () =>
            import ('./view/personal/team')
    },
    {
        path: '/myShare',
        name: 'myShare',
        component: () =>
            import ('./view/personal/myShare')
    },
    {
        path: '/trialList',
        name: 'trialList',
        component: () =>
            import ('./view/personal/trialList')
    },
    {
        path: '/trialDetails',
        name: 'trialDetails',
        component: () =>
            import ('./view/personal/trialDetails')
    },
    {
        path: '/trialpay',
        name: 'trialpay',
        component: () =>
            import ('./view/personal/trialpay')
    },
    {
        path: '/sellOrder',
        name: 'sellOrder',
        component: () =>
            import ('./view/personal/sellOrder')
    },
    {
        path: '/notice',
        name: 'notice',
        component: () =>
            import ('./view/home/notice')
    },
    {
        path: '/mywalletlist',
        name: 'mywalletlist',
        component: () =>
            import ('./view/personal/mywalletlist')
    },
    {
        path: '/goodsDetails',
        name: 'goodsDetails',
        component: () =>
            import ('./view/home/goodsDetails')
    },
    {
        path: '/payOrder',
        name: 'payOrder',
        component: () =>
            import ('./view/home/payOrder')
    },
    {
        path: '/evaList',
        name: 'evaList',
        component: () =>
            import ('./view/home/evaList')
    },
    {
        path: '/goodsEva',
        name: 'goodsEva',
        component: () =>
            import ('./view/myOrder/goodsEva')
    },
    {
        path: '/carOrder',
        name: 'carOrder',
        component: () =>
            import ('./view/shopCar/carOrder')
    },
    {
        path: '/goodscateList',
        name: 'goodscateList',
        component: () =>
            import ('./view/home/goodscateList')
    },
    // 消息
    {
        path: '/noticeDetails',
        name: 'noticeDetails',
        component: () =>
            import ('./view/home/noticeDetails')
    },
    // 注册协议
    {
        path: '/registerDetails',
        name: 'registerDetails',
        component: () =>
            import ('./view/login/noticeDetails')
    },
    // 个人中心
    {
        path: '/setting',
        name: 'setting',
        component: () =>
            import ('./view/personal/setting')
    },
    {
        path: '/resetPsd',
        name: 'resetPsd',
        component: () =>
            import ('./view/personal/resetPsd')
    },
    {
        path: '/resetpayPsd',
        name: 'resetpayPsd',
        component: () =>
            import ('./view/personal/resetpayPsd')
    },
    {
        path: '/myWallet',
        name: 'myWallet',
        component: () =>
            import ('./view/personal/myWallet')

    },
    {
        path: '/recharge',
        name: 'recharge',
        component: () =>
            import ('./view/personal/recharge')
    },
    {
        path: '/rechargeList',
        name: 'rechargeList',
        component: () =>
            import ('./view/personal/rechargeList')

    },
    {
        path: '/movedraw',
        name: 'movedraw',
        component: () =>
            import ('./view/personal/movedraw')
    },

    {
        path: '/withdraw',
        name: 'withdraw',
        component: () =>
            import ('./view/personal/withdraw')
    },
    {
        path: '/award',
        name: 'award',
        component: () =>
            import ('./view/personal/award')
    },
    {
        path: '/gather',
        name: 'gather',
        component: () =>
            import ('./view/personal/gather')
    },
    {
        path: '/myAddress',
        name: 'myAddress',
        component: () =>
            import ('./view/personal/myAddress')
    },
    {
        path: '/editAddress',
        name: 'editAddress',
        component: () =>
            import ('./view/personal/editAddress')
    },
    {
        path: '/invite',
        name: 'invite',
        component: () =>
            import ('./view/personal/invite')
    },
    // 在线留言
    {
        path: '/myEmail',
        name: 'myEmail',
        component: () =>
            import ('./view/personal/myEmail')
    },
    {
        path: '/sendEmail',
        name: 'sendEmail',
        component: () =>
            import ('./view/personal/sendEmail')
    },
    {
        path: '/emailDetails',
        name: 'emailDetails',
        component: () =>
            import ('./view/personal/emailDetails')
    },
    {
        path: '/allIntergral',
        name: 'allIntergral',
        component: () =>
            import ('./view/personal/allIntergral')
    },
    {
        path: '/todayIntergral',
        name: 'todayIntergral',
        component: () =>
            import ('./view/personal/todayIntergral')
    },
    {
        path: '/intergralTrans',
        name: 'intergralTrans',
        component: () =>
            import ('./view/personal/intergralTrans')
    },
    {
        path: '/intergralList',
        name: 'intergralList',
        component: () =>
            import ('./view/personal/intergralList')
    },
    {
        path: '/submitLevel',
        name: 'submitLevel',
        component: () =>
            import ('./view/personal/submitLevel')
    },
    {
        path: '/levelList',
        name: 'levelList',
        component: () =>
            import ('./view/personal/levelList')
    },
    // 订单
    {
        path: '/myOrder',
        name: 'myOrder',
        component: () =>
            import ('./view/myOrder')
    },
    {
        path: '/orderDetails',
        name: 'orderDetails',
        component: () =>
            import ('./view/myOrder/orderDetails')
    },
    {
        path: '/orderTeamDetails',
        name: 'orderTeamDetails',
        component: () =>
            import ('./view/myOrder/orderTeamDetails')
    },
];
const whiteList = ['register', 'forgetPsd'];
// add route path
routes.forEach(route => {
    route.path = route.path || '/';
});

const router = new Router({ routes });
router.beforeEach((to, from, next) => {
    const title = to.meta && to.meta.title;
    if (title) {
        document.title = title;
    }

    const hasToken = getToken()
    if (hasToken) {
        next();
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next()
        } else {
            next();
        }
    }

});

export {
    router
};